import React from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <div
            style={{
                textAlign: "center",
                marginTop: "0px",
                height: "100vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#fff5f7",
            }}
        >
            {/* 🔹 Add your GIF here */}
            <img
                src="https://varankal.s3.us-east-1.amazonaws.com/varankal/6d3fd8ed-a4e6-47e8-8a15-1d43d02cf83b.gif" // 👈 replace with your actual GIF path
                alt="404 Not Found"
                style={{
                    width: "300px",
                    height: "300px",
                    objectFit: "contain",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "20px",
                }}
            />

            <h1 style={{ color: "#ff3366", fontSize: "2rem", marginBottom: "10px" }}>
                404 - Page Not Found
            </h1>
            <p style={{ color: "#444", marginBottom: "20px", fontSize: "1.1rem" }}>
                The page you’re looking for doesn’t exist.
            </p>

            <button
                onClick={() => navigate("/")}
                style={{
                    backgroundColor: "#ff3366",
                    color: "white",
                    border: "none",
                    padding: "10px 20px",
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontSize: "1rem",
                    transition: "all 0.3s ease",
                }}
                onMouseOver={(e) => (e.target.style.backgroundColor = "#ff6688")}
                onMouseOut={(e) => (e.target.style.backgroundColor = "#ff3366")}
            >
                Go to Home
            </button>
        </div>
    );
};

export default NotFound;
